<template>
  <div>
    <div id="home">
      <div id="home-information" class="row">
        <h1 class="col-12">
          Olá, este é o <a>ONE</a>.
          <br />Uma plataforma criada
          para simplificar a gestão do seu negócio.
          Gerencie 
          <a>Tarefas</a>, envie
          <a>Formulários</a> e converse com 
          seus clientes pelo <a>Whatsapp</a> e
          potencialize a competividade
          da sua empresa.
        </h1>
      </div>

      <!-- <div class="ocean">
        <div class="wave"></div>
      </div> -->

      <svg xmlns="http://www.w3.org/2000/svg" 
        class="curve-container curve-three" 
        viewBox="0 0 1440 68" 
        enable-background="new 0 0 1440 68">
        <path d="m1622.3 1937.7c0 0-410.7 169.1-913.4 75.5-502.7-93.6-977.7 56.3-977.7 56.3v440h1891.1v-571.8" 
          fill="#F4F5F7" 
          transform="translate(0-1977)"></path>
      </svg>

      <div id="home-action">
        <h1 class="col-12"
        >Experimente gratuitamente por 30 dias</h1>

        <div class="buttons row col-12 col-lg-3">
          <div id="bt">
            <router-link to="/signup/task/welcome">INICIE JÁ</router-link>
          </div>

          <!-- <div id="bt">
            <router-link class="more"             
              to="/signup/business/welcome"
            >SAIBA MAIS</router-link>
          </div> -->
        </div>
        <div>
          <p
            style="text-align: center;margin:auto; padding:15px"
          >Se necessário, receba nossa ajuda personalizada por e-mail, whatsapp e telefone.</p>
        </div>
        
      </div>
    </div>
    <!-- <div class="water"></div> -->
  </div>
</template>

<script>
// <!--
// <p class="col-12 col-lg-7">
//   O One é desenvolvido pela
//   <a>TARS</a>. Nós criamos soluções como
//   <a>Walled Garden</a>
//   e prestamos
//   <a>Consultoria de Serviços de Nuvem</a> e
//   <a>Redes Corporativas</a>. E nós levamos a sério a criação de
//   ferramentas seguras e inteligentes para todas as equipes.
// </p>-->
export default {};
</script>

<style lang="scss">
@import "./node_modules/include-media/dist/_include-media.scss";

$breakpoints: (
  phone: 640px,
  tablet: 768px,
  desktop: 1024px
) !default;

#bt {
  @include media(">950px") {
    flex: 1;
  }
  margin-top: 0;
  padding: 10px;
  text-align: center;

  @include media(">phone", "<tablet") {
    font-size: 1rem;
    padding: 20px 0 10px 0;
    text-align: left;
  }

  @include media(">tablet", "<950px") {
    font-size: 1rem;
  }

  a,
  router-link {
    background-color: #25b686;
    color: #fff;
    padding: 10px 30px;
    text-decoration: none;
    font-weight: 600;
    border-radius: 4px;
    transition: background-color 0.2s;
  }

  a:hover {
    background-color: #108f65;
  }
}
.water {
  // margin-top: 10%;
  position: absolute;
  background: #bbecb5;
  height: 30%;
  width: 100%;
  z-index: -10;
}
#home {
  position: relative;
  height: 90%;

  #home-action {
    padding-top: 15px;
    background: rgb(244, 245, 247);

    h1 {
      text-align: center;
      font-weight: 800;
      margin-bottom: 30px;
      font-size: 30px;
    }

    .buttons {
      margin:auto;
      padding-bottom: 20px;

      a.more {
        color:#fff; 
        background-color: transparent;        
      }

      a.more:hover {
        color: #23a378;
      }
    }
  }
  .ocean {
    height: 10%;
    width: 100%;
    position: absolute;
    bottom: 33%;
    left: 0;
    z-index: -10;
  }

  .wave {
    margin: 0;
    background: url(../assets/wave2.svg) repeat-x;
    position: absolute;
    top: -100px;
    width: 6400px;
    height: 200px;
    animation: wave 35s cubic-bezier(0.36, 0.45, 0.63, 0.53) infinite;
    transform: translate3d(0, 0, 0);
  }

  @keyframes wave {
    0% {
      margin-left: 0;
    }
    100% {
      margin-left: -1600px;
    }
  }
  #home-information {
    margin: 0 auto;
    max-width: 1200px;
    margin-bottom: 50px;

    h1 {
      @include media(">950px") {
        font-size: 3.5rem;
      }
      
      font-weight: 500;
      color: #434242;
      margin-top: 50px;

      @include media(">phone", "<=tablet") {
        font-size: 2rem;
      }

      @include media(">tablet", "<950px") {
        font-size: 2.5rem;
      }

      a {
        color: #2fb565;
        cursor: pointer;
        transition: color 0.2s;
      }

      a:hover {
        color: #108f65;
      }
    }

    p {
      font-size: 1rem;
      margin-bottom: 40px;

      @include media(">phone", "<tablet") {
        font-size: 0.8rem;
      }

      @include media(">tablet", "<950px") {
        font-size: 1rem;
      }

      a {
        color: #2fb565;
        cursor: pointer;
        transition: color 0.2s;
      }

      a:hover {
        color: #108f65;
      }
    }
  }

  .curve-container {
    transform: scaleX(-1);
    margin-bottom: -1px;
    padding-bottom: 0;
    position: relative;
    display: block;
  }
}
</style>


